import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { SharePointProvider } from './contexts/SharePointContext';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
      <SharePointProvider>
        <Routes />
      </SharePointProvider>
    </AuthProvider>
  );
}

export default App;